import * as Breakpoint from '@app/constants/breakpoint';

// eslint-disable-next-line import/prefer-default-export
export function isMobileDeviceSize(): boolean {
  return window.innerWidth <= Breakpoint.MOBILE;
}
